import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LanguageManagementService } from '../../../service/language-management.service';
import { LocalService, MenuWrapper, PageKey } from '../../../service/local.service';
import { MenuManagementService } from '../../../service/menu-management.service';

@Component({
  selector: 'app-menu-pagekey',
  templateUrl: './menu-pagekey.component.html',
  styleUrls: ['./menu-pagekey.component.scss']
})
export class MenuPagekeyComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["menu_popup"];
  pageKey: PageKey = PageKey.None; strPageKey = '';
  wrapper: MenuWrapper; maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private menuManagementService: MenuManagementService, private languageManagementService: LanguageManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.strPageKey = PageKey[this.pageKey];
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.menuManagementService.getMenusUsedByPageKeys(this.pageKey).subscribe(result => {
      this.wrapper = result;
    });
  }
}
